import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const ExtraInfoWrapper = styled.div`
  margin-top: ${Spacing.S4};
`
